module.exports = __webpack_public_path__ + "img/pp-38.48471a17.jpg";